import styled from 'styled-components';

export const QCPartnerListContainer = styled.div`
  padding-top: 16px;
`;

export const ContainerErrorItems = styled.div`
  display: flex;
  align-items: center;
`;

export const ContainerSkeletonQC = styled.div`
  padding-bottom: 16px;
`;
